import Vue from 'vue';

Vue.component('hero', require('./hero.vue').default);
Vue.component('slider', require('./slider.vue').default);
Vue.component('amenity-map', require('./amenity-map.vue').default);
Vue.component('region-gallery', require('./region-gallery.vue').default);
Vue.component('draggable-image', require('./draggable-image.vue').default);
Vue.component('popup', require('./popup.vue').default);
Vue.component('stages', require('./stages.vue').default);
Vue.component(
	'construction-updates',
	require('./construction-updates.vue').default
);
